/* Fix khaki swatch color */
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".variant-picker__option-button--color").forEach(function(el) {
    var text = el.textContent.trim().toLowerCase();
    if (text === "khaki") {
      el.style.setProperty("--swatch-background", "rgb(195, 176, 145)", "important");
    }
  });
});